/**
 * Types du module Portes
 * 
 * Gestion des ouvertures et systèmes de portes de la tonnelle
 */

// ===== INTERFACES GÉOMÉTRIQUES =====

export interface Position3D {
  x: number;
  y: number;
  z: number;
}

export interface Point3D {
  x: number;
  y: number;
  z: number;
}

// ===== INTERFACES PORTES SIMPLIFIÉES =====

/**
 * Paramètres d'une porte individuelle - Version simplifiée
 * Matériau, couleur, épaisseur proviennent de la structure de base
 */
export interface ParametresPorte {
  id: string;
  nom: string;
  hauteur: number; // en mètres
  largeur: number; // en mètres
  nombreRepetitions: number; // nombre de portes identiques à répartir automatiquement
  formeArrondie: boolean; // true = haut arrondi, false = rectangulaire
  actif: boolean;
}

/**
 * Paramètres globaux du module Portes - Version simplifiée
 */
export interface ParametresPortes {
  actif: boolean;
  portes: ParametresPorte[];
  hauteurDefaut: number;
  largeurDefaut: number;
  nombreRepetitionsDefaut: number;
  formeArrondieDefaut: boolean;
}

/**
 * Structure géométrique d'une porte générée
 */
export interface ElementPorte {
  id: string;
  nom: string;
  geometrie: {
    coins: Point3D[];
    centre: Point3D;
    normale: Point3D;
    surface: number;
    formeArrondie: boolean;
  };
  parametres: ParametresPorte;
  vertices: number[];
  indices: number[];
  materiaux: {
    diffuse: string;
    ambient: string;
    specular: string;
    shininess: number;
    transparency: number;
  };
}

/**
 * Structure complète des portes
 */
export interface StructurePortes {
  id: string;
  timestamp: number;
  parametres: ParametresPortes;
  elements: ElementPorte[];
  statistiques: {
    nombrePortes: number;
    surfaceTotale: number;
    poidesEstime: number; // en kg
  };
}

/**
 * Données de la structure de base nécessaires pour les portes
 */
export interface DonneesStructureBasePourPortes {
  forme: string;
  largeur: number;
  longueur: number;
  hauteur: number;
  nombreMontants: number;
  positionsMontants: Position3D[];
  materiau: string;
  epaisseur: number;
  couleur: string;
  poutreHaute?: {
    points: Point3D[];
  };
  poutreBasse?: {
    points: Point3D[];
  };
  centre: Position3D;
}

/**
 * État du module Portes
 */
export interface PortesState {
  parametres: ParametresPortes;
  structure?: StructurePortes;
  isGenerating: boolean;
  error?: string;
  editeurActif: boolean;
  porteSelectionnee?: string;
}

// ===== VALEURS PAR DÉFAUT =====

export const PARAMETRES_PORTES_DEFAUT: ParametresPortes = {
  actif: false,
  portes: [],
  hauteurDefaut: 2.0,
  largeurDefaut: 1.2,
  nombreRepetitionsDefaut: 1,
  formeArrondieDefaut: false
};

// ===== TYPES LEGACY SUPPRIMÉS =====
// Les types TypeStylePorte, TypeMateriauPorte, TypeFixationPorte et COULEURS_MATERIAUX_PORTES
// ont été supprimés car remplacés par le système simplifié qui utilise directement
// les matériaux, couleurs et épaisseurs de la structure de base